import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Radio, Table } from 'antd';
import { Medal } from '@phosphor-icons/react';
import Typography from '../../components/Typography';
import COLORS from '../../util/constants/colors';
import { captureAnalytics } from '../../actions/preload';

const HIGHEST = 'highest';
const LOWEST = 'lowest';

const TopProviders = ({ topProviders, lowestProviders, loading }) => {
  const [ranking, setRanking] = useState(HIGHEST);

  const changeRanking = (event) => {
    setRanking(event.target.value);
    captureAnalytics('referring_providers_ranking_changed', { ranking: event.target.value });
  };

  const columns = [
    {
      title: 'PROVIDER',
      dataIndex: 'provider_name',
      key: 'provider_name',
    },
    {
      title: 'FACILITY',
      dataIndex: 'provider_office',
      key: 'provider_office',
    },
    {
      title: 'REFERRALS',
      dataIndex: 'referral_count',
      key: 'referral_count',
    },
    {
      title: 'CONVERSION RATE',
      dataIndex: 'percentage_scheduled',
      key: 'percentage_scheduled',
      render: (text) => `${text.toFixed(2)}%`,
    },
  ];

  return (
    <div className="top-providers-section">
      <div className="top-providers-header">
        <Typography variant="text" size="medium" bold className="referral-trends-header">
          <Medal color={COLORS.ATTENTION_LITE} size={16} weight="bold" />
          &nbsp;
          {ranking === HIGHEST ? 'Top Referring Providers' : 'Lowest Referring Providers'}
        </Typography>
        <div data-testid="referring-providers-ranking">
          <Radio.Group size="small" value={ranking} onChange={changeRanking}>
            <Radio.Button value={HIGHEST}>Highest</Radio.Button>
            <Radio.Button value={LOWEST}>Lowest</Radio.Button>
          </Radio.Group>
        </div>
      </div>
      <Table
        className="top-providers-table"
        pagination={false}
        columns={columns}
        dataSource={ranking === HIGHEST ? topProviders : lowestProviders}
        style={{ width: '100%', height: '100%' }}
        scroll={{ y: 250 }}
        loading={loading}
      />
    </div>
  );
};

const providerRowShape = PropTypes.shape({
  provider_name: PropTypes.string,
  provider_office: PropTypes.string,
  referral_count: PropTypes.number,
  percentage_scheduled: PropTypes.number,
});

TopProviders.propTypes = {
  topProviders: PropTypes.arrayOf(providerRowShape),
  lowestProviders: PropTypes.arrayOf(providerRowShape),
  loading: PropTypes.bool,
};

TopProviders.defaultProps = {
  topProviders: [],
  lowestProviders: [],
  loading: false,
};

export default TopProviders;
